<script lang="ts">
  import type { HTMLComponent } from "$lib/js/strapi/types";
  import '$lib/css/components/html.scss'

  export let component: HTMLComponent
</script>


<div class="html">
  {@html component.html}
</div>
